import styled from 'styled-components'
import tw from 'twin.macro'

export const FormWrapper = styled.div`
  max-width: 720px;
  ${tw`mx-auto`}

  section {
    ${tw`pb-8 px-0`}

    > div {
      ${tw`px-0`}
    }
  }

  .form-group {
    ${tw`mb-2`}

    > input {
      ${tw`h-10`}
    }
  }

  button {
    ${tw`mt-4`}
  }

  .you-fitness__control {
    height: 40px !important;
    min-height: 40px !important;
  }

  .privacy-policy {
    ${tw`w-full`}
    flex: 1 1 100% !important;
  }
`
